define('lq/datasources',[
    'underscore',
    'lq/queryDispatcher',
    'lq/util'
], function (_, QueryDispatcher, util) {
    'use strict';

    var Datasources = function () {
        this.datasourceListeners = [];
        this.datasources = [];
    };

    Datasources.prototype.registerDatasourceListener = function (queryName, handler, decorateDataFunc) {
        var id = _.uniqueId();
        this.datasourceListeners.push({
            id: id,
            queryName: queryName,
            handler: handler,
            decorateDataFunc: decorateDataFunc
        });
        return id;
    };

    Datasources.prototype.getDatasourceListenersThatListenFor = function (queryName) {
        return _.where(this.datasourceListeners, { queryName: queryName });
    };

    Datasources.prototype.getDatasourceListenersThatListenForWithDefaultParams = function (queryName) {
        var defaultParams = QueryDispatcher.getDefaultQueryParams();
        return _.filter(this.getDatasourceListenersThatListenFor(queryName), function (listener) {
            if (typeof (listener.decorateDataFunc) !== "function")
                return true;
            var params = QueryDispatcher.getDefaultQueryParams();
            listener.decorateDataFunc(params);
            return _.isEqual(defaultParams, params);
        });
    };

    Datasources.prototype.unregisterDatasourceListener = function (id) {
        var listenerToRemove = this.getDatasourceListener(id);
        this.datasourceListeners = _.without(this.datasourceListeners, listenerToRemove);
    };

    Datasources.prototype.getDatasourceListener = function (id) {
        return _.findWhere(this.datasourceListeners, { id: id });
    };

    Datasources.prototype.registerDatasource = function (datasource) {
        if (datasource.id != null) {
            _.each(datasource.outputs, function (output, index) {
                datasource.outputs[index] = util.convertListOfKeyValuesToObject(output);
            });
            this.datasources.push(datasource);
        }
    };

    Datasources.prototype.getDatasources = function () {
        return util.cloneData(this.datasources);
    };

    Datasources.prototype.getDatasourceNames = function (datasourceTypesToIgnore) {
        return _.chain(this.datasources)
            .filter(function (d) {
                return !!d.name && (!datasourceTypesToIgnore || datasourceTypesToIgnore.indexOf(d.type) === -1);
            })
            .groupBy(function(d) {
                return d.name;
            })
            .map(function (datasources, datasourceName) {
                return {
                    name: datasourceName,
                    unique: datasources.length === 1
                };
            })
            .sortBy(function (d) {
                return d.name.toLowerCase();
            })
            .value();
    };

    Datasources.prototype.getDatasourceByName = function (dataSourceName) {
    	return _.findWhere(this.datasources, { name: dataSourceName });
    };

    Datasources.prototype.getEntityTypeOfDatasource = function (dataSourceName) {
        var datasource = this.getDatasourceByName(dataSourceName);
        return datasource ? datasource.entityDefinitionName : null;
    };

    Datasources.prototype.getDatasourceOutputs = function (dataSource) {
        if ($.type(dataSource) === 'string')
    	    dataSource = this.getDatasourceByName(dataSource);

    	if (!dataSource)
    		return [];

    	return _.chain(dataSource.outputs)
            .filter(function(output) {
                return !output.hideField && output.alias;
	        })
            .pluck('alias')
            .sortBy(function(a) {
	            return a.toLowerCase();
	        })
            .value();
    };

    Datasources.prototype.updateDatasource = function (datasource) {
    	this.unregisterDatasource(datasource);
        this.registerDatasource(datasource);
    };

    Datasources.prototype.unregisterDatasource = function (datasource) {
        this.datasources = _.filter(this.datasources, function (d) { return d.id !== datasource.id; });
    };

    Datasources.prototype.clear = function () {
        this.datasourceListeners = [];
        this.datasources = [];
    };

    return Datasources;
});
